import axios from 'axios';

// Base URL for the backend API
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  // Do NOT set Content-Type globally! We'll handle it per-request below.
});

// Interceptor: Set Content-Type to application/json only for plain objects (JSON payloads)
api.interceptors.request.use(config => {
  if (
    config.data &&
    typeof config.data === 'object' &&
    !(config.data instanceof FormData) &&
    !(config.data instanceof URLSearchParams)
  ) {
    config.headers['Content-Type'] = 'application/json';
  }
  // For FormData or URLSearchParams, let the browser/axios set Content-Type
  return config;
});

// Common error handler
export const handleApiError = (error, defaultMessage = 'An error occurred') => {
  console.error('API Error:', error);
  
  if (error.response?.data) {
    const errorData = error.response.data;
    
    // Handle FastAPI validation errors (422)
    if (Array.isArray(errorData.detail)) {
      return errorData.detail.map(err => 
        `${err.loc?.join('.')} - ${err.msg}`
      ).join(', ');
    }
    
    // Handle string detail messages
    if (typeof errorData.detail === 'string') {
      return errorData.detail;
    }
    
    // Handle other error formats
    if (errorData.message) {
      return errorData.message;
    }
  }
  
  return defaultMessage;
};

export { api, API_BASE_URL };
export default api;
